module.exports = __webpack_public_path__ + "img/sku.fedc06ee.png";